import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";




export default function Pagination({ itemsPerPage, items, setItems }) {
    const [pageCount, setPageCount] = useState(0);
    const { t } = useTranslation()
    const [selectedPage, setselectedPage] = useState(0)


    useEffect(() => {
        setPageCount(Math.ceil(items.length / itemsPerPage));

        // reset selected page if items changes
        handlePageClick({ selected: 0 })
    }, [items])


    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        const endOffset = newOffset + itemsPerPage;

        setselectedPage(event.selected)
        setItems(items.slice(newOffset, endOffset));
    };


    if (items?.length > 0) {
        return (

            <ReactPaginate
                className="pagination justify-content-center"
                previousLabel={t("previousLabel")}
                nextLabel={t("nextLabel")}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                nextClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextLinkClassName={"page-link"}
                disabledClassName={"disabled"}
                forcePage={selectedPage}
            />

        )
    } else return (null)
}